export default defineComponent({
  inheritAttrs: false
});